<template>
    <b-modal
        v-model="isVisible"
        size="lg"
        id="file-manager-modal"
        :no-close-on-backdrop="true"
        :hide-footer="true"
        :title="managerTitle"
    >
        <file-manager
            v-if="hotInstance && resourceId"
            resource-type="report-row"
            :resource-id="resourceId"
            @updated-files="filesUpdated"
        ></file-manager>
    </b-modal>
</template>

<script>
import { BaseEditorComponent } from "@handsontable/vue";
import FileManager from "../Common/FileManager";
export default {
  name: "InputPhotoEditor",
  components: {
    FileManager
  },
  extends: BaseEditorComponent,
  data: function() {
    return {
      // We'll need to define properties in our data object,
      // corresponding to all of the data being injected from
      // the BaseEditorComponent class, which are:
      // - hotInstance (instance of Handsontable)
      // - row (row index)
      // - col (column index)
      // - prop (column property name)
      // - TD (the HTML cell element)
      // - originalValue (cell value passed to the editor)
      // - cellProperties (the cellProperties object for the edited cell)
      hotInstance: null,
      managerTitle: "",
      TD: null,
      row: null,
      col: null,
      prop: null,
      originalValue: null,
      value: "",
      cellProperties: null,
      isVisible: false,
      resourceId: null
    };
  },
  mounted() {},
  methods: {
    filesUpdated(files) {
      this.hotInstance.setDataAtRowProp(this.row, "photos", files.length);
    },
    prepare: function(row, col, prop, td, originalValue, cellProperties) {
      // We'll need to call the `prepare` method from
      // the `BaseEditorComponent` class, as it provides
      // the component with the information needed to use the editor
      // (hotInstance, row, col, prop, TD, originalValue, cellProperties)
      BaseEditorComponent.options.methods.prepare.call(
        this,
        row,
        col,
        prop,
        td,
        originalValue,
        cellProperties
      );

      // @todo make sure that we dont open the dialog if the row has not yet been saved

      this.managerTitle =
        "File manager for row #" + this.hotInstance.getDataAtRowProp(row, "id");

      /** @see https://handsontable.com/docs/7.1.1/frameworks-wrapper-for-vue-hot-column.html#custom-editor */

      this.$root.$on("bv::modal::shown", e => {
        if (e.componentId === "file-manager-modal") {
          document
            .getElementById("file-manager-modal")
            .addEventListener("mousedown", e => {
              e.stopPropagation();
            });
        }
      });

      this.resourceId = this.hotInstance.getDataAtRowProp(row, "id");
    },
    open: function() {
      this.isVisible = true;
    },
    close: function() {},
    setValue: function(value) {
      this.value = value;
    },
    getValue: function() {
      return this.value;
    }
  }
};
</script>

<style scoped>
</style>
